import { Component, inject, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Mdladdproduct } from '../../mdl-add-product/mdl-add.product';
import { MatDialog } from '@angular/material/dialog';
import { Api } from '../../../services/api';
import { AlertService } from '../../../services/alert.service';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { MdlCreatePItem } from '../../mdl-create-p-item/mdl-create-p-item';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

@Component({
  selector: 'app-recursos-budget',
  imports: [CurrencyPipe, CommonModule],
  templateUrl: './recursos-budget.html',
  styleUrl: './recursos-budget.css',
})
export class RecursosBudget {
  readonly dialog = inject(MatDialog);
  private api = inject(Api);
  private alertService = inject(AlertService);
  @Input() presupuesto_id!: string;

  constructor(private router: Router) {}
  items: any[] = [];
  isLoading = false;
  uploadingFiles: boolean = false;
  uploadedFiles: any[] = [];
  versiones: any[] = [];


  ngOnInit(): void {
    if (this.presupuesto_id) {
      console.log('📦 Cargando items del presupuesto:', this.presupuesto_id);
      this.cargarItemsPresupuesto();
      this.cargarVersionesPDF();
      this.getEntityFiles();
    }
  }

  cargarVersionesPDF(): void {
    this.api.getBudgetVersions({ presupuesto_id: this.presupuesto_id }).subscribe({
      next: (response: any) => {
        this.versiones = response.versiones || [];
        console.log('📄 Versiones PDF cargadas:', this.versiones);
      },
      error: (error) => {
        console.error('❌ Error al cargar versiones PDF:', error);
      }
    });
  }


  cargarItemsPresupuesto(): void {
    console.log('🔄 Cargando items del presupuesto...');
    this.isLoading = true;
    this.api.getBudgetItems(this.presupuesto_id).subscribe({
      next: (res: any) => {
        this.items = res.presupuesto_items || [];
        console.log('✅ Items cargados:', this.items);
        this.isLoading = false;
      },
      error: (err) => {
        console.error('❌ Error cargando items:', err);
        this.isLoading = false;
      },
    });
  }

  navigateToFullTable(event: Event): void {
    const value = (event.target as HTMLButtonElement).value;

    if (value === 'detail') {
      this.router.navigate(['/budget-detail-table'], {
        queryParams: { id: this.presupuesto_id },
      });
    } else if (value === 'pdf') {
      this.router.navigate(['/budget-pdf-table'], {
        queryParams: { id: this.presupuesto_id },
      });
    }
  }

  openAddProductModal() {
    this.dialog.open(Mdladdproduct, {
      width: '1200px',
      maxWidth: '95vw',
      height: 'auto',
      panelClass: 'mat-dlg-class',
      data: {
        presupuestoId: this.presupuesto_id,
      },
    }).afterClosed().subscribe(() => {
      window.location.reload();
    }
    );
  }

  openAddPItemModal() {
    this.dialog.open(MdlCreatePItem, {
      width: '800px',
      maxWidth: '95vw',
      maxHeight: '80vh',
      panelClass: 'mat-dlg-class',
      data: {
        presupuestoId: this.presupuesto_id,
      },
    }); 
  }

  onFileSelected(event: any) {
    const files: FileList = event.target.files;
    
    if (files && files.length > 0) {
      this.uploadingFiles = true;
      
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        console.log('Archivo seleccionado:', file.name);
        this.uploadFile(file);
      }
    }
    
    event.target.value = '';
  }

  uploadFile(file: File) {
    this.api.showLoading();
    const formData = new FormData();
    formData.append('file', file);
    formData.append('id_entidad', this.presupuesto_id);
    formData.append('tipo', 'BGT');
    
    this.api.uploadFile(formData).subscribe({
      next: (response: any) => {
        this.api.hideLoading();
        console.log('Archivo subido exitosamente:', response);
        
        if (response.success) {
          this.getEntityFiles();
          this.alertService.success('Éxito', 'El archivo fue subido exitosamente');
        }
      },
      error: (error: any) => {
        this.api.hideLoading();
        console.error('Error al subir archivo:', error);
        this.alertService.error('Error', `No se pudo subir el archivo: ${file.name}`);
      },
      complete: () => {
        this.uploadingFiles = false;
      }
    });
  }

onDeleteFile(file: any) {
    const confirmDelete = confirm(`¿Deseas eliminar el archivo "${file.nombre}"?`);

    if (!confirmDelete) return;

    this.api.showLoading();
    this.api.deleteFile({ fileUrl: file.url }).subscribe({
      next: (res: any) => {
        this.api.hideLoading();
        if (res.success) {
          this.uploadedFiles = this.uploadedFiles.filter(f => f.url !== file.url);
          this.alertService.success('Éxito', 'El archivo fue eliminado correctamente');
        } else {
          this.alertService.error('Error', res.message || 'No se pudo eliminar el archivo');
        }
      },
      error: (err: any) => {
        this.api.hideLoading();
        if (err.status === 403) {
          this.alertService.error('Acceso denegado', 'No tienes permiso para eliminar archivos.');
          return;
        }
        console.error('Error al eliminar archivo:', err);
        this.alertService.error('Error', 'No se pudo eliminar el archivo.');
      }
    });
  }

  getEntityFiles() {
    this.api.getEntityFiles({id_entidad: this.presupuesto_id}).subscribe({
      next: (data: any) => {
        this.uploadedFiles = data.data;
      },
      error: (error: any) => {
        console.error('Error fetching files:', error);
      }
    });
  }

  formatFileSize(bytes: number): string {
    if (bytes === 0) return '0 Bytes';
    
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }

buildVersionFileName(v: any): string {
  const num = v.version ?? 1;

  const numPresu =
    v.presupuesto_data?.cabecera?.numero_presupuesto ||      
    this.presupuesto_id ||                      
    'SIN_ID';

  return `COT_${numPresu}_V${num}.pdf`;
}

downloadVersionPDF(v: any): void {
  const data = v.presupuesto_data || {};
  const cab = data.cabecera || {};
  const totales = data.totales || {};
  const detalle = data.productos || [];

  const fakePresupuesto: any = {
    numero_presupuesto:
      cab.numero_presupuesto ||
      this.presupuesto_id,

    fecha_creacion: cab.fecha_creacion || v.fecha_creacion,

    subtotal: Number(totales.subtotal ?? 0),
    impuestos: Number(totales.impuestos ?? 0),
    envio: Number(totales.envio ?? 0),
    descuento_global: Number(totales.descuento_global ?? 0),
    precio_total: Number(totales.precio_total ?? 0),

    presupuesto_item: (detalle || []).map((d: any) => ({
      producto_servicio: d.producto_servicio,
      cantidad: d.cantidad,
      precio_unitario: d.precio_unitario,
    })),

    contacto: {
      cuenta: {
        nombre_empresa: cab.cliente?.nombre_empresa || '-',
        rut: cab.cliente?.rut || '-',
        direccion_env: cab.cliente?.direccion_env || '-',
      },
    },

    ejecutivo: {
      nombre: cab.ejecutivo?.nombre || '',
      apellido: cab.ejecutivo?.apellido || '',
      email: cab.ejecutivo?.email || '',
    },
  };

  const fileName = this.buildVersionFileName(v);
  console.log('🧾 Generando PDF de versión con:', fakePresupuesto);
  this.generarPDFDesdePresupuesto(fakePresupuesto, fileName);
}


private generarPDFDesdePresupuesto(p: any, fileName: string) {
  console.log('PDF: generarPDFDesdePresupuesto ejecutada');
  if (!p) return;

  const doc = new jsPDF('p', 'mm', 'a4');
  const colorOrg: [number, number, number] = [230, 90, 20];
  const colorGray: [number, number, number] = [80, 80, 80];
  const margenX = 20;
  let y = 20;

  // === LOGO ===
  try {
    const logo = new Image();
    logo.src = 'assets/img/logo.png';
    doc.addImage(logo, 'PNG', margenX, 15, 38, 15);
  } catch {
    console.warn('⚠️ No se pudo cargar el logo');
  }

  // === TÍTULO ===
  doc.setFontSize(18);
  doc.setTextColor(colorOrg[0], colorOrg[1], colorOrg[2]);
  doc.text('PRESUPUESTO', 190 - margenX, 25, { align: 'right' });
  doc.setDrawColor(colorOrg[0], colorOrg[1], colorOrg[2]);
  doc.setLineWidth(0.8);
  doc.line(135, 27, 190 - margenX, 27);

  // === DATOS DERECHA ===
  doc.setFontSize(10);
  doc.setTextColor(0, 0, 0);

  let rightY = 35;
  const labelX = 130;
  const valueX = 185;
  const lineSpacing = 8;

  function printRow(label: string, value: string) {
    doc.text(label, labelX, rightY);
    doc.text(value || '-', valueX, rightY, { align: 'right' });
    rightY += lineSpacing;
  }

  printRow('Número presupuesto:', p.numero_presupuesto || '-');
  printRow(
    'Fecha presupuesto:',
    p.fecha_creacion ? new Date(p.fecha_creacion).toLocaleDateString('es-CL') : '-'
  );
  printRow(
    'Fecha caducidad:',
    p.fecha_caducidad ? new Date(p.fecha_caducidad).toLocaleDateString('es-CL') : '-'
  );

  // === DATOS EMPRESA ===
  y = 40;
  doc.setFontSize(10);
  doc.text('TIC Services SPA', margenX, y);
  y += 5;
  doc.text('RUT: 76.423.634-3', margenX, y);
  y += 5;
  doc.text(
    'Av. del Parque 4928, Of 224, Huechuraba, Región Metropolitana.',
    margenX,
    y
  );

// === INFO COMPRADOR Y PREPARADO POR ===
y += 15;
doc.setFontSize(12);
doc.setTextColor(colorOrg[0], colorOrg[1], colorOrg[2]);
doc.text('Información comprador:', margenX, y);
doc.text('Preparado por:', 120, y);
y += 6;

doc.setFontSize(10);
doc.setTextColor(0, 0, 0);

const cuenta = p.contacto?.cuenta;
const comprador = cuenta?.nombre_empresa || '-';
const rut = cuenta?.rut || '-';
const direccion = cuenta?.direccion_env || '-';
const ejecutivo = p.ejecutivo || {};

const lineH = 5;

// ancho real de la columna izquierda (en mm)
const leftColWidth = 85;

// wrap automático por palabras según ancho real
function wrapByWidth(text: string, maxWidth: number) {
  const words = text.split(' ');
  const lines: string[] = [];
  let line = '';

  for (const w of words) {
    const test = line ? `${line} ${w}` : w;
    if (doc.getTextWidth(test) <= maxWidth) {
      line = test;
    } else {
      if (line) lines.push(line);
      line = w;
    }
  }
  if (line) lines.push(line);
  return lines.length ? lines : ['-'];
}

// IZQUIERDA
const nombreLines = wrapByWidth(`Nombre empresa: ${comprador}`, leftColWidth);
nombreLines.forEach((line, idx) => {
  doc.text(line, margenX, y + idx * lineH);
});
let leftY = y + nombreLines.length * lineH;

doc.text(`RUT: ${rut}`, margenX, leftY);
leftY += lineH;

const direccionLines = wrapByWidth(`Dirección: ${direccion}`, leftColWidth);
direccionLines.forEach((line, idx) => {
  doc.text(line, margenX, leftY + idx * lineH);
});
leftY += direccionLines.length * lineH;

// DERECHA: misma altura inicial que la izquierda
let rightYBlock = y;
doc.text(`Nombre: ${ejecutivo.nombre || '-'}`, 120, rightYBlock);
rightYBlock += lineH;
doc.text(`Correo: ${ejecutivo.email || '-'}`, 120, rightYBlock);

// Actualizar y global
y = Math.max(leftY, rightYBlock) + 5;


  // === TABLA ===
  y += 10;

  const agrupados = new Map<
    string,
    { cantidad: number; total: number; precio_unitario: number }
  >();

  (p.presupuesto_item || []).forEach((item: any) => {
    const nombre = item.producto_servicio || '—';
    const cantidad = Number(item.cantidad || 1);
    const precio = Number(item.precio_unitario || 0);
    const subtotal = precio * cantidad;

    if (agrupados.has(nombre)) {
      const existente = agrupados.get(nombre)!;
      existente.cantidad += cantidad;
      existente.total += subtotal;
    } else {
      agrupados.set(nombre, {
        cantidad,
        total: subtotal,
        precio_unitario: precio,
      });
    }
  });

  const productos = Array.from(agrupados.entries()).map(([nombre, data]) => [
    nombre,
    `$ ${data.precio_unitario.toLocaleString('es-CL')}`,
    data.cantidad,
    `$ ${data.total.toLocaleString('es-CL')}`,
  ]);

  autoTable(doc, {
    startY: y,
    head: [['Producto', 'Precio de venta', 'Cantidad', 'Precio Total']],
    body: productos,
    theme: 'grid',
    styles: {
      fontSize: 9,
      cellPadding: 3,
      lineColor: [200, 200, 200],
      lineWidth: 0.2,
    },
    headStyles: {
      fillColor: colorOrg,
      textColor: 255,
      halign: 'center',
      fontStyle: 'bold',
    },
    columnStyles: {
      0: { cellWidth: 80 },
      1: { halign: 'right' },
      2: { halign: 'center' },
      3: { halign: 'right' },
    },
  });

  const finalY = (doc as any).lastAutoTable.finalY + 10;

  const subtotal = Number(p.subtotal || 0);
  const impuestos = Number(p.impuestos || 0);
  const envio = Number(p.envio || 0);
  const descuento = Number(p.descuento_global || 0);
  const total = Number(p.precio_total || 0);
  const descuentoMonto = subtotal * (descuento / 100);

  let lineY = finalY + 6;
  const labelTotX = 130;
  const valueTotX = 185;

  doc.setFontSize(11);
  doc.setTextColor(60, 60, 60);

  function printTotalRow(label: string, value: string) {
    doc.text(label, labelTotX, lineY);
    doc.text(value, valueTotX, lineY, { align: 'right' });
    lineY += lineSpacing;
  }

  printTotalRow('Subtotal:', `$ ${subtotal.toLocaleString('es-CL')}`);

  if (descuento > 0) {
    printTotalRow(
      `Descuento (${descuento}%):`,
      `- $ ${descuentoMonto.toLocaleString('es-CL')}`
    );
  }

  printTotalRow('Impuestos (19%):', `$ ${impuestos.toLocaleString('es-CL')}`);
  printTotalRow('Costo de envío:', `$ ${envio.toLocaleString('es-CL')}`);

  const boxWidth = 60;
  const boxHeight = 10;
  const boxY = lineY + 5;

  doc.setFillColor(colorOrg[0], colorOrg[1], colorOrg[2]);
  doc.rect(labelTotX, boxY, boxWidth, boxHeight, 'F');

  doc.setTextColor(255, 255, 255);
  doc.setFontSize(12);
  doc.text(
    `Total: $ ${total.toLocaleString('es-CL')}`,
    valueTotX,
    boxY + 7,
    {
      align: 'right',
    }
  );

  doc.setFontSize(9);
  doc.setTextColor(130);
  doc.text(
    `Documento generado automáticamente por CRM TIC Service — ${new Date().toLocaleString(
      'es-CL'
    )}`,
    105,
    287,
    { align: 'center' }
  );

  doc.save(fileName || `Presupuesto_${p.nombre_presupuesto || 'documento'}.pdf`);
}


}
